<template>
  <div>
    <div
      v-if="!tableData.length && fetchingTiming"
      class="text-center py-4"
    >
      <b-spinner />
    </div>
    <template v-else>
      <div class="d-lg-none px-2 py-1">
        <timing-logs-list
          :logs="tableData"
          empty-text="No timing logs found for this output"
        />
      </div>

      <div class="d-none d-lg-block">
        <b-table
          ref="table"
          :items="tableData"
          :fields="fields"
          responsive
          class="loaded border-default border-b border-r border-l mb-0"
          show-empty
          empty-text="No timing logs found for this output"
          :busy="fetchingTiming"
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(startDateTime)="data">
            {{ formatDateTimeDetailed(data.value) }}
          </template>
        </b-table>
      </div>
    </template>
  </div>
</template>

<script>
import TimingLogsList from '../components/TimingLogsList.vue'

export default {
  name: 'OutputTimingLogs',
  components: {
    TimingLogsList,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      initialized: false,
      fields: [
        { key: 'index', label: '' },
        'status',
        { key: 'messageComment', label: 'message' },
        { key: 'startDateTime', label: 'timestamp' },
      ],
      tableData: [],
      fetchingTiming: false,
    }
  },
  watch: {
    visible(val) {
      if (val && !this.initialized) {
        this.initialized = true
        this.fetchTiming()
      }
    },
  },
  created() {
    this.fetchTiming()
  },
  methods: {
    fetchTiming() {
      this.fetchingTiming = true
      this.$store.dispatch('jobs/getJobTiming', {
        jobId: this.$route.params.name,
        outputId: this.id,
      }).then(res => {
        this.fetchingTiming = false
        this.tableData = res.data.result
      }).catch(() => {
        this.fetchingTiming = false
      })
    },
  },

}
</script>

<style>

</style>
